export const RequestHeaders = {
  'Content-Type': 'application/json',
} as const;

export const ACCESS_TOKEN_COOKIE_NAME = 'net_net_access_token';
export const REFRESH_TOKEN_COOKIE_NAME = 'net_net_refresh_token';
